<ng-container *transloco="let t">

  <app-loader [loading]="loading"></app-loader>

  <form *ngIf="loading !== true" (submit)="onSubmit()" novalidate>

    <div class="card p-mb-4">
      <div class="p-grid">
        <div class="p-col-6">
          <h1>{{ t("common.labels.neworder") }}</h1>
        </div>
        <div class="p-col-6 p-text-right">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()" [cancelHidden]="auth.hasRights !== true" [submitLabel]="(auth.hasRights !== true) ? t('common.labels.create_order') : null"></app-form-buttons>
        </div>
      </div>

      <p-messages [(value)]="messages"></p-messages>

      <app-orderform-jobinformation [form]="form" [options]="options" [texts]="texts" (changed)="jobChanged($event)" #jobinformation> </app-orderform-jobinformation>
    </div>

    <app-orderform-template
      [form]="form"
      [options]="options"
      [templates]="filteredTemplates"
      [businessunit]="selectedBusinessunit"
      [texts]="texts"
      [disabled]="form.get('jobinformation').valid !== true"
      (changed)="templateChanged($event)"
      #template
    >
    </app-orderform-template>

    <app-orderform-own-observers
      [form]="form"
      [options]="options"
      [texts]="texts"
      [disabled]="form.get('jobinformation').valid !== true || form.get('template').valid !== true"
      (changed)="ownObserversChanged($event)"
      #ownobservers
    >
    </app-orderform-own-observers>

    <app-orderform-date
      [form]="form"
      [options]="options"
      [texts]="texts"
      [disabled]="form.get('jobinformation').valid !== true || form.get('template').valid !== true"
      #date
    ></app-orderform-date>

    <app-orderform-candidate
      [form]="form"
      [options]="options"
      [texts]="texts"
      [disabled]="form.get('jobinformation').valid !== true || form.get('template').valid !== true || form.get('date').valid !== true"
      #candidate
    ></app-orderform-candidate>

    <app-orderform-participants
      [form]="form"
      [options]="options"
      [texts]="texts"
      [user]="user"
      [disabled]="form.get('jobinformation').valid !== true || form.get('template').valid !== true || form.get('date').valid !== true || form.get('candidate').valid !== true"
      #participants
    >
    </app-orderform-participants>

    <div class="card p-mb-4">
      <app-orderform-documents
      [form]="form"
      [options]="options"
      [texts]="texts"
      [needsJobDescription]="needsJobDescription"
      #documents
    ></app-orderform-documents>

      <p class="p-mt-4" [innerHtml]="texts.orderform_final_sentence"></p>

      <div class="p-text-right">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()" [cancelHidden]="auth.hasRights !== true" [submitLabel]="(auth.hasRights !== true) ? t('common.labels.create_order') : null"></app-form-buttons>
      </div>
    </div>

  </form>
</ng-container>
